import { DETAILS_EMPTY_PLACEHOLDER } from '@/shared/constants';

/**
 * InfoGrid displays a list of label-value pairs in a responsive 2-column grid.
 * It supports optional colSpan (1 or 2) for each item, and applies left/right padding
 * to maintain spacing between columns. If a value is empty, a placeholder is shown.
 */
const InfoGrid = ({ items }) => {
    let currentCol = 0; // 0: first column, 1: second column

    return (
        <div className="p-4 grid grid-cols-1 md:grid-cols-2">
            {items.map(({ label, value, colSpan }, idx) => {
                // Clamp colSpan to 1 or 2
                const maxColSpan = 2;
                const safeColSpan = colSpan === maxColSpan ? maxColSpan : 1;
                const colSpanClass = `col-span-1 md:col-span-${safeColSpan}`;

                // Get the padding class based on current column
                let paddingClass = '';
                if (safeColSpan === 1) {
                    paddingClass = currentCol === 0 ? 'md:pr-2' : 'md:pl-2';
                }
                // Update the current col
                if (safeColSpan === 2) {
                    currentCol = 0; // Reset to first column after a full-width item
                } else {
                    currentCol = (currentCol + 1) % 2; // Toggle between 0 and 1
                }

                return (
                    <div
                        key={label}
                        className={`flex flex-col gap-1 border-t border-solid border-t-[#cedbe8] py-4 ${colSpanClass} ${paddingClass}`}
                    >
                        <div className="text-[#49739c] text-sm font-normal leading-normal">{label}</div>
                        <div className="text-[#0d141c] text-sm font-normal leading-normal">
                            {value !== undefined && value !== null && value !== '' ? value : DETAILS_EMPTY_PLACEHOLDER}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default InfoGrid;
